import muster from '@dbk-legacy/muster';
import {Base64} from 'js-base64';
import { variable } from '@dbk-legacy/muster/helpers';
import { getValues } from '@dbk-legacy/muster/utils';
import { PAYMENTS_PATH } from './constant';
import Guid from '../../../utils/guid';
import isValidJsonString from '../../../utils/is-valid-json-string';
import { pipeTemplate, toNumber } from './parser'
import { EBANKINGWEBLUX, EBANKINGWEBUK } from '../../../constants';
import envConfig  from '../../../../db-env-build';

export default () => muster()
  .path('payments.getPaymentHistory', {
    call: async ({ req }, { get, set }) => {
      const forceUpdate = req.args[0] === 'refetch'
      const [list] = await getValues(get('payments.transactionList'))
      if (!forceUpdate && list.length) {
        // when dashboard page displayed again
        // do nothing, so there is no loading circle and no data updated.
      } else {
        set('payments.transactionListLoading', true);
        const channel = 'WEB';
        const deviceCode = ''
        const inputs = `${deviceCode}#@#${channel}`;
        const url = `${PAYMENTS_PATH}.listTransactions.["${inputs}"]["${Guid()}"]`
        const [result] = await getValues(get(url));
        try {
          const data = JSON.parse(result)
          if(envConfig.envConfig === EBANKINGWEBLUX){
            const dataWithoutDomPay= data.resultList.filter((paymentItem) => (paymentItem.paymentType.paymentTypeName !== "DOMESTIC_PAYMENT" && paymentItem.paymentType.paymentTypeName !== "SWISS_QR_BILL_PAYMENT"));
            await set('payments.transactionList', dataWithoutDomPay);
          }else if(envConfig.envConfig === EBANKINGWEBUK){
            const dataWithoutSepaPay= data.resultList.filter((paymentItem) => (paymentItem.paymentType.paymentTypeName !== "SEPA_PAYMENT" && paymentItem.paymentType.paymentTypeName !== "SWISS_QR_BILL_PAYMENT"));
            await set('payments.transactionList', dataWithoutSepaPay);
          }else{
            await set('payments.transactionList', data.resultList);
          }
        } catch (e) {
          set('payments.transactionList', []);
        }
        set('payments.transactionListLoading', false);
      }
    },
  })

  //  Payment Template starts here-------

  .path('payments.getTemplateList', {
    call: async ({ req }, { get, set }) => {
      const [messages] = await getValues(get('i18n.messages'));
      const guidStr = Guid();
      const [listData] = await getValues(get(`${PAYMENTS_PATH}.getTemplateList["${guidStr}"]`))
      isValidJsonString(listData).then(async data => {
        if (data && data.errorCode) {
          await Promise.all[(
            set('payments.errorMsg', data.message),
            set('payments.templateErrorModal', true),
            set('payments.loading', false)
          )]
        } else {
          await Promise.all[(
            set('payments.templateList', data),
            set('payments.loading', false))]
        }
      })
        .catch(async error => {
          await Promise.all[(
            set('payments.errorMsg', messages['app.payments.failToConnect']),
            set('payments.templateErrorModal', true),
            set('payments.loading', false)
          )]
        })
    }
  })

  .path('payments.deleteTemplate', {
    call: async ({ req }, { get, set, call }) => {
      const templateId = req.args[0];
      await set('payments.loading', true);
      const [messages] = await getValues(get('i18n.messages'));
      const request = {
        templateId
      }
      const requestObj = Base64.encode(JSON.stringify(request));
      const guidStr = Guid();
      const inputParam = `${requestObj}`;
      const [oReturn] = await getValues(
        get(`${PAYMENTS_PATH}.deleteTemplate["${inputParam}"]["${guidStr}"]`)
      )
      isValidJsonString(oReturn)
        .then(async (data) => {
          if (data && data.templateId) {
            await call('payments.getTemplateList');
            await set('payments.deleteConfirmationModal', false);
            await set('payments.loading', false);
          } else if (data && data.errorCode) {
            await Promise.all([
              set('payments.errorMsg', data.message),
              set('payments.templateErrorModal', true),
              set('payments.loading', false)])
          }
        })
        .catch(async (error) => {
          await Promise.all([
            set('payments.errorMsg', messages['app.payments.failToConnect']),
            set('payments.templateErrorModal', true),
            set('payments.loading', false)])
        })
    }
  })

  .path('payments.initializePaymentCapture', {
    call: async ({ req }, { get, set, call }) => {

      await set('payments.isPaymentTemplateFlow', true); // required to change the title on Payment capture screen
      const [selectedTemp] = await getValues(get('payments.selectedPaymentTemplate'));

      // Populate Debit list
      const [debitList] = await getValues(get('payments.debtAcList'));
      const cashAccNo = selectedTemp.cashAccNo;
      const cashAccPfId = selectedTemp.cashAccPfId;
      const selectedAcnt = debitList && debitList.find(e => e.accNo === cashAccNo && e.pfId === cashAccPfId);
      await set('payments.paymentType', selectedTemp.paymentType && selectedTemp.paymentType.toLowerCase());
      await set('payments.selectedDebitAcnt', selectedAcnt);

      //Populate Beneficiary or Credit Account List
      if (selectedTemp.paymentType && selectedTemp.paymentType.toLowerCase().includes('internal')) {
        const toAccNo = selectedTemp.toCashAccNo;
        const toAccPfId = selectedTemp.toCashAccPfId;
        const selectedAcnt = debitList && debitList.find(e => e.accNo === toAccNo && e.pfId === toAccPfId);
        await set('payments.selectedCreditAcnt', selectedAcnt); // for internal payment type
      } else {
        const [beneficiaryList] = await getValues(get('payments.beneficiaryList'));
        const selectedBenf = beneficiaryList && beneficiaryList.find(e => e.beneficiaryId === selectedTemp.beneficiaryId);
        await call('payments.setBeneficiary', selectedBenf); // for all payment type except for  internal
      }

      // Populate Amout Fields
      const [currencyList] = await getValues(get('payments.curcyWhiteList'));
      const selectedCurrency = currencyList && currencyList.find(e => e.tech === selectedTemp.currencyTech && e.currencyKey === selectedTemp.currencyKey);
      await set('payments.selectedCurrency', selectedCurrency);
      await set('payments.amount', selectedTemp.amount);

      //Populate cost type
      const [selectedCostList] = await getValues(get('payments.costList'));
      const selectedCost = selectedCostList && selectedCostList.find(e => e.costTypeKey === parseInt(selectedTemp.costTypeKey));
      await set('payments.selectedCost', selectedCost);

      // Poppulate Payment Reason and payment addition Information from Remarks
      let remarks = selectedTemp.remarks;
      if(remarks != '') {
        let sliceIndex = remarks.indexOf('-');
        if(sliceIndex > 0) {
          let remarksArray = [remarks.slice(0,sliceIndex), remarks.slice(sliceIndex+1)];
          set('payments.remarks', remarksArray[1]);
          set('payments.paymentReason', remarksArray[0]);
        } else {
          set('payments.remarks', remarks);
          // set('payments.paymentReason', '');
        }
      }
    }
  })

  .path('payments.saveUpdateTemplate', {
    call: async ({ req }, { get, set, call }) => {
      await set('payments.loading', true);
      const [overrideTemp] = await getValues(get('payments.overrideTemp'));
      const [selectedPaymentTemplate, templateName,paymentType, selectedDebitAcnt, selectedCurrency, amount, selectedBeneficiaryBank, selectedCreditAcnt, selectedCost, paymentReason, messages] = await getValues(
                          get(['payments.selectedPaymentTemplate','payments.templateName',
                          'payments.paymentType','payments.selectedDebitAcnt',
                          'payments.selectedCurrency','payments.amount','payments.selectedBeneficiaryBank','payments.selectedCreditAcnt','payments.selectedCost', 'payments.paymentReason', 'i18n.messages']))
      
      let [remarks] = await getValues(get(['payments.remarks']));
      if(paymentReason && paymentReason != '') {
        remarks = `${paymentReason}-${remarks}`;
      }
      const request = pipeTemplate({selectedPaymentTemplate, templateName,paymentType, selectedDebitAcnt, selectedCurrency, amount: toNumber(amount), selectedBeneficiaryBank, 
        selectedCreditAcnt, remarks, selectedCost})
      
      if(overrideTemp){
         request.templateId = overrideTemp.templateId; // fix for WMCE-12691
      }
      const inputParam = Base64.encode(JSON.stringify(request));
      const guidStr = Guid();
      const [oReturn] = await getValues(
        get(`${PAYMENTS_PATH}.saveUpdateTemplate["${inputParam}"]["${guidStr}"]`)
      )
      isValidJsonString(oReturn)
        .then(async (data) => {
          if (data && data.templateId) {
            await set('payments.loading', false);
          } else if (data && data.errorCode) {
            await Promise.all([
              set('payments.errorMsg', data.message),
              set('payments.templateErrorModal', true),
              set('payments.loading', false)])
          }
        })
        .catch(async (error) => {
          await Promise.all([
            set('payments.errorMsg', messages['app.payments.failToConnect']),
            set('payments.templateErrorModal', true),
            set('payments.loading', false)])
        })
    }
  })

    // reset values of template item variables
    .path('payments.resetTemplateVariables', {
      call: async ({ req }, { get, set, call }) => {
        await Promise.all([
          set('payments.isPaymentTemplateFlow', false),
          set('payments.templateName', null),
          set('payments.isSaveEnabled', false),
          set('payments.selectedPaymentTemplate', null)])
    }})

  //  Payment Template ends here-------

  .path('payments.transactionListLoading', variable(false))
  .path('payments.transactionList', variable([]))
  .path('payments.templateList', variable())
  .path('payments.selectedPaymentTemplate', variable())
  .path('payments.isPaymentTemplateFlow', variable(false))
  .path('payments.templateName', variable())
  .path('payments.saveModifiedTemplate', variable(false))
  .path('payments.isSaveEnabled', variable(false))
  .path('payments.templateErrorModal', variable(false))
  .path('payments.overrideTemp', variable(null))


